<script>
  import { Tabs } from "bits-ui";
  import { logClickToGA } from "$lib/utils/analytics.js";

  let { chart = undefined, map = undefined } = $props();
</script>

<div class="pt-6">
  <Tabs.Root value="chart" class="">
    <div class="tab-wrapper">
      <Tabs.List class="tab-list">
        <Tabs.Trigger
          value="chart"
          class="tab-control"
          onclick={(e) => logClickToGA(e.currentTarget, "click-chart-tab")}>Chart</Tabs.Trigger
        >
        <Tabs.Trigger
          value="map"
          class="tab-control"
          onclick={(e) => logClickToGA(e.currentTarget, "click-map-tab")}>Map</Tabs.Trigger
        >
      </Tabs.List>
    </div>
    <Tabs.Content value="chart" class=""
      >{#if chart}{@render chart()}{/if}</Tabs.Content
    >
    <Tabs.Content value="map" class=""
      >{#if map}{@render map()}{/if}</Tabs.Content
    >
  </Tabs.Root>
</div>

<style>
  .tab-wrapper {
    border-bottom: solid 2px var(--color-gray-shade-light);
    margin-bottom: var(--spacing-8);
    margin-top: var(--spacing-4);
  }
  div :global(.tab-list) {
    margin-inline: auto;
    display: flex;
    max-width: 768px;
    gap: var(--spacing-2);
    font-weight: var(--font-weight-bold);
  }
  div :global(.tab-control) {
    cursor: pointer;
    margin: 0;
    border: solid 2px var(--color-black);
    padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
    font-size: var(--font-size-lg);
    background: var(--color-black);
    font-family: inherit;
    color: var(--color-white);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-large);
    line-height: 28px;
  }
  div :global(.tab-control:hover) {
    background: var(--color-white);
    border-bottom: none;
    color: var(--color-black);
  }
  div :global(.tab-control[data-state="active"]) {
    background: white;
    color: black;
    border: solid 2px var(--color-gray-shade-light);
    position: relative;
    /* @apply border-b-4 border-b-[var(--color-yellow)] text-black; */
  }
  div :global(.tab-control[data-state="active"]::after) {
    content: "";
    width: 100%;
    border-bottom: solid 4px white;
    position: absolute;
    bottom: -4px;
    left: 0;
    right: 0;
  }
  div :global(.tab-control:focus-visible) {
    outline: solid 2px var(--color-blue-shade-darker);
    outline-offset: 2px;
  }
</style>
